/**
 * Module
 */
require('./app/app.module.js');

/**
 * Constants
 */
require('./app/app.constants.js');

/**
 * Directives
 */
require('./app/shared/ccNumeric/mitomNumericDrct');

/**
 * Custom filters
 */
require('./app/app.filters.js');

/**
 * Components
 */

require('./app/components/mitoman-gestione-utente/gestioneUtente.component');
require('./app/components/mitoman-gestione-utente/gestioneUtente.service');

require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/accessoNotifiche.component');
require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/accessoNotifiche.service');
require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-notifiche/notifiche.component');
require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-notifiche/notifiche.service');
require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-vip-access/vipAccess.component');
require('./app/components/mitoman-gestione-utente/mitoman-accesso-notifiche/mitoman-vip-access/vipAccess.service');

require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/datiUtenteMito.component');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/datiUtenteMito.service');
require('./app/components/mitoman-gestione-utente/mitoman-dati-credenziali/datiCredenziali.component');
require('./app/components/mitoman-gestione-utente/mitoman-dati-credenziali/datiCredenziali.service');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-contatti/contatti.component');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-contatti/contatti.service');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-conto-addebito/contoAddebito.component');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-conto-addebito/contoAddebito.service');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-dati-utente/datiUtente.component');
require('./app/components/mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-dati-utente/datiUtente.service');

require('./app/components/mitoman-gestione-utente/mitoman-visibilita-rapporti/visibilitaRapporti.component');
require('./app/components/mitoman-gestione-utente/mitoman-visibilita-rapporti/visibilitaRapporti.service');

require('./app/components/mitoman-invio-credenziali/invioCredenziali.component');
require('./app/components/mitoman-invio-credenziali/invioCredenziali.service');
require('./app/components/mitoman-invio-credenziali/mitoman-invio-credenziali-sezione/invioCredenzialiSezione.component');
require('./app/components/mitoman-invio-credenziali/mitoman-invio-credenziali-sezione/invioCredenzialiSezione.service');

require('./app/components/mitoman-audit/audit.component');
require('./app/components/mitoman-audit/audit.service');

require('./app/components/mitoman-vip/vip.component');
require('./app/components/mitoman-vip/vip.service');

require('./app/components/mitoman-gestione-documenti/gestioneDocumenti.component');
require('./app/components/mitoman-gestione-documenti/gestioneDocumenti.service');

/**
 * Modals
 */
require('./app/modals/sceltaUtenza/sceltaUtenza.service');
require('./app/modals/sceltaUtenza/sceltautenza.controller');
require('./app/modals/verificaUtenza/verificaUtenza.service');
require('./app/modals/verificaUtenza/verificaUtenza.controller');
require('./app/modals/storicoDinamico/storicoDinamico.service');
require('./app/modals/storicoDinamico/storicoDinamico.controller');
require('./app/modals/storicoModificheContatti/storicoModificheContatti.service');
require('./app/modals/storicoModificheContatti/storicoModificheContatti.controller');
require('./app/modals/aggiuntaDispositivo/aggiuntaDispositivo.service');
require('./app/modals/aggiuntaDispositivo/aggiuntaDispositivo.controller');
require('./app/modals/contoMancante/contoMancante.controller');
require('./app/modals/gestioneNote/gestioneNote.controller');
require('./app/modals/estinzione/estinzione.controller');

/**
 * Spinner
 */
require('./app/components/vvSpinner/vvSpinner.component');

/**
 * Services
 */

require('./app/shared/services/label.srvc.js');
require('./app/shared/services/messaggi.fctr.js');
require('./app/shared/services/user.srvc.js');
require('./app/shared/services/logger.srvc.js');
require('./app/shared/services/general.srvc.js');
require('./app/shared/services/download.srvc.js');

/**
 * Run
 */
require('./app/app.run.js');

/**
 * Config
 */
require('./app/app.route.js');